import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-3 px-10 text-white dark:text-gray-800 bg-cyan hover:opacity-75 font-bold rounded-full w-full"
}
const _hoisted_2 = {
  key: 1,
  class: "py-3 px-10 text-white dark:text-gray-800 bg-cyan hover:opacity-75 font-bold rounded w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.name == 'full')
      ? (_openBlock(), _createElementBlock("button", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_ctx.name == 'simple')
        ? (_openBlock(), _createElementBlock("button", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
  ]))
}